export const ConsumerRouteResolverStyles = {
  container: 'mt-6',
  paragraph: 'mt-8'
}
